const en = {
    estateSearch: {
        loading: 'The properties are being loaded ...',
        search: 'Search',
        emptyFilter: 'Empty filter',
        noResults: 'Sorry we couldn\'t find any results for your search.',
        noResultsCTA: 'Niet gevonden wat je zocht?',
        noResultsCTADescription: 'Schrijf je in en ontvang nieuwe panden die met uw zoekcriteria overeenkomen via e-mail',
        noResultsCTAButton: 'Subscribe',
        cheapestFirst: 'Price cheapest first',
        mostExpensiveFirst: 'Price most expensive first',
        oldestFirst: 'Oldest first',
        newestFirst: 'Newest first',
        result: 'result',
        results: 'results',
        showMap: 'show map',
        hideMap: 'hide map',
        found: 'found',
        sortBy: 'sort by',
        selected: 'selected',
    },
};

export { en };
